var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgEyeInvisible = function SvgEyeInvisible(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.655 7.162c-1.335-1.41-3.228-3.17-5.542-4.605C20.8 1.127 18.042.003 15 0c-3.042.003-5.8 1.127-8.112 2.557C4.573 3.992 2.68 5.75 1.345 7.162A4.848 4.848 0 0 0 0 10.5a4.851 4.851 0 0 0 1.345 3.337c1.335 1.411 3.228 3.17 5.543 4.606C9.2 19.873 11.958 20.997 15 21c3.042-.003 5.8-1.127 8.113-2.557 2.315-1.436 4.207-3.195 5.542-4.605A4.852 4.852 0 0 0 30 10.5a4.853 4.853 0 0 0-1.345-3.338Zm-1.978 1.886a2.1 2.1 0 0 1 .596 1.452 2.101 2.101 0 0 1-.596 1.452c-1.222 1.294-2.966 2.903-4.996 4.16-2.034 1.26-4.33 2.152-6.681 2.15-2.352.002-4.647-.89-6.68-2.15-2.031-1.257-3.775-2.866-4.997-4.16a2.101 2.101 0 0 1-.596-1.452c.002-.51.186-1.016.595-1.451C4.545 7.753 6.29 6.144 8.32 4.889c2.034-1.262 4.33-2.153 6.681-2.15 2.352-.003 4.647.888 6.68 2.15 2.031 1.255 3.775 2.864 4.997 4.159Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4.49c-3.306 0-5.984 2.69-5.985 6.01.001 3.32 2.68 6.01 5.985 6.01 3.306 0 5.984-2.69 5.985-6.01 0-3.32-2.679-6.01-5.985-6.01Zm0 9.282a3.27 3.27 0 0 1-3.258-3.272A3.27 3.27 0 0 1 15 7.228a3.27 3.27 0 0 1 3.258 3.272A3.27 3.27 0 0 1 15 13.772Z"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgEyeInvisible);
export default ForwardRef;